import { PractitionerUpdatedEvent } from '@dreryk/egabinet-personnel-frontend-api';

import { useCqrsEvent } from '@dreryk/command-query-react-common';

import { useRefetchCurrentPractitioner } from './useRefetchCurrentPractitioner';

export const PractitionerUpdatedEventListener = (): null => {
   const refetchCurrentPractitioner = useRefetchCurrentPractitioner();

   useCqrsEvent<PractitionerUpdatedEvent>('egabinet-personnel-frontend-api:PractitionerUpdatedEvent', () => {
      refetchCurrentPractitioner();
   });

   return null;
};
